import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useMemo, useCallback } from "react";
import { TooltipPortal } from "@animech/ui";
import { t } from "i18next";
import * as Styled from "./edge.style";
import { EditButtonIcon, EditButtons, } from "ui/components/elements/edit-buttons/edit-buttons";
import { CanvasOverlay, StyledCanvasOverlay, } from "ui/components/panels/canvas/overlay-elements/canvas-overlay";
import { round, Unit } from "utility/number";
import { useAppDispatch, actions } from "store";
import { KeyBindings, useKeyBindings } from "hooks/keybindings";
import { TubeSettings } from "ui/components/elements/tube-settings/tube-settings";
var supportedKeyboardKeys = [KeyBindings.DELETE, KeyBindings.ESCAPE];
export var EdgeOverlay = function (_a) {
    var app = _a.app, edge = _a.edge, middlePosition = _a.middlePosition, isSelected = _a.isSelected, isMultiSelecting = _a.isMultiSelecting, hideEdge = _a.hideEdge, isDoubleTube = _a.isDoubleTube, onCurveLengthChange = _a.onCurveLengthChange;
    var dispatch = useAppDispatch();
    useKeyBindings({
        edge: edge,
        keys: supportedKeyboardKeys,
        disabled: isMultiSelecting || !isSelected,
    });
    var onChangeDefaultDiameter = useCallback(function (diameter, index) {
        dispatch(actions.setEdgeDiameterDefaultTube({
            edgeIds: [edge.id],
            diameter: diameter,
            index: index,
        }));
    }, [dispatch, edge.id]);
    var onChangeBlowOffDiameter = useCallback(function (diameter, index) {
        dispatch(actions.setEdgeDiameterBlowOffTube({
            edgeIds: [edge.id],
            diameter: diameter,
            index: index,
        }));
    }, [dispatch, edge.id]);
    var isUsingCustomDefaultDiameter = edge.defaultDiameterIndex === undefined;
    var edgeEjectorTubeDiameterIndexes = useMemo(function () {
        return edge.defaultDiameterIndex === undefined
            ? []
            : [edge.defaultDiameterIndex];
    }, [edge.defaultDiameterIndex]);
    var edgeBlowOffTubeDiameterIndexes = useMemo(function () { return (edge.blowOffDiameterIndex ? [edge.blowOffDiameterIndex] : []); }, [edge.blowOffDiameterIndex]);
    var labelAndButtons = useMemo(function () {
        if (hideEdge)
            return null;
        if (middlePosition) {
            var cameraEntity = app.root.findByName("Camera");
            var camera = cameraEntity === null || cameraEntity === void 0 ? void 0 : cameraEntity.camera;
            if (!camera)
                return;
            var position = camera.worldToScreen(middlePosition);
            var deleteAction = {
                icon: EditButtonIcon.DELETE,
                action: function () { return dispatch(actions.deleteEdge(edge.id)); },
            };
            var setTubeLengthLocked_1 = function (isLocked) {
                dispatch(actions.setEdgeLengthLocked({ edgeIds: [edge.id], isLocked: isLocked }));
            };
            var defaultDiameter = "" + edge.diameterDefaultTube * 1000;
            var blowOffDiameter = "" + edge.diameterBlowOffTube * 1000;
            return (_jsx(_Fragment, { children: !isMultiSelecting && isSelected && (_jsxs(_Fragment, { children: [_jsx(TooltipPortal
                        /* We need to acces the styled component directly when used as an anchor element
                         * Otherwise the position cannot be calculated properly for the TooltipPortal */
                        , { 
                            /* We need to acces the styled component directly when used as an anchor element
                             * Otherwise the position cannot be calculated properly for the TooltipPortal */
                            anchorElement: _jsx(StyledCanvasOverlay, { x: position.x, y: position.y }), open: true, children: _jsx(Styled.InputTooltip, { pointerEvents: isSelected, children: _jsxs(Styled.ContentWrapper, { children: [_jsx(Styled.LengthWrapper, { children: _jsx(Styled.Length, { value: edge.length, min: 0, max: 20, unit: Unit.M, type: "float", setValue: function (value) {
                                                    onCurveLengthChange(value);
                                                    dispatch(actions.setEdgeLength({
                                                        edgeIds: [edge.id],
                                                        length: round(value),
                                                        isLocked: true,
                                                    }));
                                                }, lock: {
                                                    isLocked: edge.lengthLocked === true,
                                                    onLock: function () { return setTubeLengthLocked_1(true); },
                                                    onUnlock: function () { return setTubeLengthLocked_1(false); },
                                                }, label: t("sidebar.edit_tube.tube_length") }) }), _jsx(TubeSettings, { tubeType: edge.tubeType, isUsingCustomValue: isUsingCustomDefaultDiameter, label: isDoubleTube
                                                ? t("sidebar.edit_tube.tube_diameter_tooltip_double_ejector")
                                                : t("sidebar.edit_tube.tube_diameter_tooltip"), onValueChange: onChangeDefaultDiameter, value: defaultDiameter, valueIndexes: edgeEjectorTubeDiameterIndexes }), isDoubleTube && (_jsx(Styled.TubeSettingsWrapper, { children: _jsx(TubeSettings, { tubeType: edge.tubeType, isBlowOffTube: true, isUsingCustomValue: false, label: t("sidebar.edit_tube.tube_diameter_tooltip_double_blow_off"), onValueChange: onChangeBlowOffDiameter, value: blowOffDiameter, valueIndexes: edgeBlowOffTubeDiameterIndexes }) }))] }) }) }), _jsx(CanvasOverlay, { x: position.x, y: position.y - 40, children: _jsx(EditButtons, { actions: [deleteAction] }) })] })) }));
        }
        return null;
    }, [
        hideEdge,
        middlePosition,
        app.root,
        edge.diameterDefaultTube,
        edge.diameterBlowOffTube,
        edge.length,
        edge.lengthLocked,
        edge.id,
        isMultiSelecting,
        isSelected,
        isUsingCustomDefaultDiameter,
        isDoubleTube,
        onChangeDefaultDiameter,
        edgeEjectorTubeDiameterIndexes,
        onChangeBlowOffDiameter,
        edgeBlowOffTubeDiameterIndexes,
        dispatch,
        onCurveLengthChange,
        edge.tubeType,
    ]);
    return _jsx(_Fragment, { children: labelAndButtons });
};
